import * as React from 'react'
import AuthComponent from '../components/Auhentication/LoginComponent/AuthComponent'
import GlobalClientDashboardContainer from '../containers/Global/GlobalClientDashboardContainer'
import SchoolMaterialThemeContainer from '../containers/SchoolMaterialThemeContainer'
import { useSchoolDetails } from '../hooks/useSchoolDetails'
import SchoolUserPageHead from '../components/SchoolUserPageHead'
import InfoAppBar from '@/components/SchoolHomepage/DefaultHomepage/InfoAppBar'
import SchoolHomePageNotificationBanner from '@/components/SchoolHomepage/DefaultHomepage/SchoolHomePageNotificationBanner'

const Login = () => {
  const { error, schoolDetails } = useSchoolDetails()
  if (error) return null
  if (!schoolDetails) {
    return null
  }
  return (
    <>
      <SchoolUserPageHead schoolDetails={schoolDetails} />
      <SchoolMaterialThemeContainer schoolDetails={schoolDetails}>
        <GlobalClientDashboardContainer>
          <div
            style={{
              position: 'relative',
              backgroundColor: 'rgb(244, 245, 247)',
            }}
          >
            <div
              style={{
                minHeight: '90vh',
              }}
            >
              <InfoAppBar
                school_details={schoolDetails}
                defaultStyle={{
                  backgroundColor: '#fff',
                  // height: "60px",
                }}
              />
              <SchoolHomePageNotificationBanner schoolDetails={schoolDetails} />

              <AuthComponent
                onSuccess={() => {
                  console.log('successful')
                }}
                school_details={schoolDetails}
              />
            </div>
          </div>
        </GlobalClientDashboardContainer>
      </SchoolMaterialThemeContainer>
    </>
  )
}

export default Login
